import { NumberField, SelectField } from 'components';
import { useCalculator } from 'contexts/Calculator/Calculator';
import { DEFAULT_VALUES, DISTRIBUTION_FUNCTIONS, GOALS } from '../../../constants';
import FunctionInfo from './FunctionInfo';
import GoalInfo from './GoalInfo';
import ThresholdInfo from './ThresholdInfo';

export default function Setup() {

    const calculator = useCalculator();

    return (
        <div className="row mb-5">
            <div className="col-12 mb-4 col-md-6 col-lg-4">
                <SelectField
                    aria-label="Goal"
                    data-testid="analyze-goal-select"
                    defaultValue={DEFAULT_VALUES.goal}
                    info={GoalInfo}
                    label="Goal"
                    name="goal"
                    options={GOALS}
                    value={calculator.goal}
                    onChange={calculator.setGoal}
                />
            </div>
            <div className="col-12 mb-4 col-md-6 col-lg-4">
                <SelectField
                    aria-label="Function"
                    data-testid="analyze-function-select"
                    defaultValue={DEFAULT_VALUES.distributionFunction}
                    info={FunctionInfo}
                    label="Function"
                    name="function"
                    options={DISTRIBUTION_FUNCTIONS}
                    value={calculator.distributionFunction}
                    onChange={calculator.setDistributionFunction}
                />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
                <NumberField
                    aria-label="Threshold"
                    data-testid="analyze-threshold-input"
                    info={ThresholdInfo}
                    label="Threshold"
                    name="threshold"
                    optional
                    placeholder="ex. 40%"
                    type="percentage"
                    value={calculator.threshold}
                    onChange={calculator.setThreshold}
                />
            </div>
        </div>
    );
}
